/**
 * Phonics Letter Gg — 课程数据配置
 * Gg.mp4 Chant 时间段同 Song (0:11~1:18)
 */

const MEDIA_BASE = '/media/phonics/gg';
const V = 'v2';

export const letterData = {
  letter: 'G',
  title: 'Phonics',
  subtitle: 'Letter Gg',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Gg.mp4?${V}`,
    startTime: 11,
    endTime: 78,
  },

  // Step 2: 4格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image7.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
  ],

  // 统一 storySections（Vocab + Story）
  storySections: [

    // Vocab 组1：chew / chewing
    {
      label: 'Learn the words (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words1_chewing.mp4?${V}`, poster: `${MEDIA_BASE}/image11.png?${V}` }],
      splitAt: 2,
      lines: [
        { en: 'chew', cn: '咬、嚼', audioEn: `${MEDIA_BASE}/w_en_chew.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_chew.mp3?${V}` },
        { en: 'chewing', cn: '正在嚼', audioEn: `${MEDIA_BASE}/w_en_chewing.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_chewing.mp3?${V}` },
      ],
    },

    // Vocab 组2：like / likes
    {
      label: 'Learn the words (2)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words2_likes.mp4?${V}`, poster: `${MEDIA_BASE}/image12.png?${V}` }],
      splitAt: 2,
      lines: [
        { en: 'like', cn: '喜欢', audioEn: `${MEDIA_BASE}/w_en_like.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_like.mp3?${V}` },
        { en: 'likes', cn: '喜欢', audioEn: `${MEDIA_BASE}/w_en_likes.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_likes.mp3?${V}` },
      ],
    },

    // Vocab 组3：bubble / bubble gum
    {
      label: 'Learn the words (3)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words3_bubble.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      splitAt: 2,
      lines: [
        { en: 'bubble', cn: '泡泡', audioEn: `${MEDIA_BASE}/w_en_bubble.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_bubble.mp3?${V}` },
        { en: 'bubble gum', cn: '泡泡糖', audioEn: `${MEDIA_BASE}/w_en_bubble_gum.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_bubble_gum.mp3?${V}` },
      ],
    },

    // Story 1 — Goat
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_goat.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      lines: [
        { en: 'Goat is chewing gum.', cn: '山羊在嚼口香糖', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'Goat likes bubble gum.', cn: '山羊喜欢嚼泡泡糖', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
      ],
    },

    // Story 2 — Goose
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_goose.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` }],
      lines: [
        { en: 'Goose is chewing gum.', cn: '鹅在嚼口香糖', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'Goose likes bubble gum.', cn: '鹅喜欢嚼泡泡糖', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
      ],
    },

    // Story 3 — Gorilla（无中文）
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_gorilla.mp4?${V}`, poster: `${MEDIA_BASE}/image16.png?${V}` }],
      lines: [
        { en: 'Gorilla is chewing gum.', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}` },
        { en: 'Gorilla likes bubble gum.', audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
